<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	let { config }: { config: BrandConfig } = $props();

	// Default value
	const defaultBrandNameRelationship = 'Artificer Innovations, LLC';

	// Use brand-specific value if provided, otherwise fall back to default
	const brandNameRelationship = config.legalIntroSettings?.brandNameRelationship ?? defaultBrandNameRelationship;
</script>

<div class="legal-intro">
	<p>
		This Refund Policy outlines the terms and conditions for refunds, cancellations, and returns for both our consulting services and digital products offered by <strong>{brandNameRelationship}</strong>. This policy applies to all websites and brands operated by Artificer Innovations, LLC.
	</p>
</div>

<style>
	.legal-intro {
		margin-bottom: 0;
	}

	.legal-intro p {
		font-size: 1rem;
		line-height: 1.6;
		color: var(--text-color);
		margin: 0 0 1rem 0;
	}

	.legal-intro strong {
		color: var(--accent-color);
		font-weight: 600;
	}
</style>
